import React from 'react'
import './Apps.css'
import ios from './app-img/5-1.png'
import android from './app-img/6.png'
import mob from './app-img/30-800x800.png'

const APP_URL = "https://aizoplug.com/apps/";

const Apps = () => {
  const openAppPage = () => {
    window.open(APP_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div className='app-main'>
      <div className="app-content-main">
        <div className="app-content">
          <div className="app-content-head" data-aos="fade-up">
            <p>Find Charging Stations Near You With Our App</p>
          </div>

          <div className="app-content-note" data-aos="fade-up">
            <p>
              Find EV charging stations near you with the AIZO Plug app.
              Convenient, fast, and reliable solutions at your fingertips.
            </p>
          </div>

          <div className="app-content-button" data-aos="fade-up">
            <img
              src={ios}
              alt="Download on iOS"
              className="app-store-btn"
              onClick={openAppPage}
            />

            <img
              src={android}
              alt="Download on Android"
              className="app-store-btn"
              onClick={openAppPage}
            />
          </div>
        </div>

        <div className="app-img" data-aos="fade-up">
          <img src={mob} alt="AIZO Plug mobile app preview" />
        </div>
      </div>
    </div>
  )
}

export default Apps
